import React from 'react';
import { Column } from '@ant-design/plots';

const CollectiveAgreementChart = () => {
  const data = [
    { year: '2018', quarter: 'Q1', employees: 1600, percentage: 12.2 },
    { year: '2018', quarter: 'Q2', employees: 1700, percentage: 13.0 },
    { year: '2018', quarter: 'Q3', employees: 1700, percentage: 13.5 },
    { year: '2018', quarter: 'Q4', employees: 1700, percentage: 13.8 },
    { year: '2019', quarter: 'Q1', employees: 1700, percentage: 13.0 },
    { year: '2019', quarter: 'Q2', employees: 1800, percentage: 13.5 },
    { year: '2019', quarter: 'Q3', employees: 1700, percentage: 13.7 },
    { year: '2019', quarter: 'Q4', employees: 1800, percentage: 14.0 },
    { year: '2020', quarter: 'Q1', employees: 1700, percentage: 13.5 },
    { year: '2020', quarter: 'Q2', employees: 1800, percentage: 13.8 },
    { year: '2020', quarter: 'Q3', employees: 1800, percentage: 14.0 },
    { year: '2020', quarter: 'Q4', employees: 1800, percentage: 14.2 },
    { year: '2021', quarter: 'Q1', employees: 1800, percentage: 14.0 },
    { year: '2021', quarter: 'Q2', employees: 1900, percentage: 14.5 },
    { year: '2021', quarter: 'Q3', employees: 1800, percentage: 14.3 },
    { year: '2021', quarter: 'Q4', employees: 1700, percentage: 15.0 },
  ];

  const config = {
    data,
    theme: "classicDark",
    height: 160,
    isGroup: true,
    xField: 'year',
    yField: 'employees',
    seriesField: 'quarter', // Field that defines the groups
    color: ['#6CD2FF', '#3E9EEB', '#2E7DDF', '#1D5FC8'], // Each color corresponds to a 'quarter'
    legend: false, // Disable default legend

    label: {
      position: 'top',
      formatter: (datum) => `${(datum.employees / 1000).toFixed(1)}k`,
      style: { fill: '#595959' },
    },
    xAxis: {
      title: null,
    },
    yAxis: {
      title: null,
    },
    meta: {
      employees: {
        alias: 'Employees',
        formatter: (value) => `${value / 1000}k`,
      },
    },
  };

  return (
    <div style={{ padding: '20px', borderRadius: '8px'}}>
      <div style={{ textAlign: 'center', fontSize: '14px', marginBottom: '10px', color: '#595959' }}>
       
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', fontSize: '12px' }}>
        <span style={{ color: '#6CD2FF', marginRight: '8px' }}>12.2%</span> -
        <span style={{ color: '#1D5FC8', marginLeft: '8px' }}>15.0%</span>
      </div>
      <Column {...config} />
    </div>
  );
};

export default CollectiveAgreementChart;
